module.exports = __webpack_public_path__ + "static/img/b5.d0334f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/b5.png
// module id = /GZf
// module chunks = 0